export class Anonymization {
  constructor(readonly isEnabled: boolean) {}
}
